import { render, staticRenderFns } from "./TutorialsDocuments.vue?vue&type=template&id=885cd74a&scoped=true&"
import script from "./TutorialsDocuments.vue?vue&type=script&lang=js&"
export * from "./TutorialsDocuments.vue?vue&type=script&lang=js&"
import style0 from "./TutorialsDocuments.vue?vue&type=style&index=0&id=885cd74a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885cd74a",
  null
  
)

export default component.exports